<template>
  <div class="app-container">
    <el-form :model="searchData" :inline="true" label-width="140px" label-position="right" ref="searchData">
      <el-form-item label="京东工单号" prop="orderNo">
        <el-input v-model="searchData.orderNo" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="回收订单号" prop="recycleNo">
        <el-input v-model="searchData.recycleNo" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="条码" prop="barCode">
        <el-input v-model="searchData.barCode" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="旧机状态" prop="oldMachineStatusList">
        <el-select v-model="searchData.oldMachineStatusList" placeholder="请选择" clearable style="width: 100%" multiple>
          <el-option v-for="item in oldMachineStatusList" :key="item.value" :label="item.label" :value="Number(item.value)"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="仓库编号" prop="stationId">
        <el-input v-model="searchData.stationId" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="省" prop="provinceIds">
        <el-select v-model="searchData.provinceIds" multiple placeholder="请选择" clearable style="width: 100%" @change="provinceChangeFun">
          <el-option v-for="item in provinceListNew" :key="item.provinceId" :label="item.province" :value="item.provinceId" style="width: 100%"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="市" prop="cityIds">
        <el-select v-model="searchData.cityIds" multiple placeholder="请选择" clearable style="width: 100%" @change="cityChangeFun" :disabled="isCityDisabled">
          <el-option v-for="item in cityListNew" :key="item.cityId" :label="item.city" :value="item.cityId" style="width: 100%"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="区" prop="countyIds">
        <el-select v-model="searchData.countyIds" multiple placeholder="请选择" clearable style="width: 100%" :disabled="isDistrictDisabled">
          <el-option v-for="item in districtListNew" :key="item.countyId" :label="item.county" :value="item.countyId" style="width: 100%"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="仓库名称" prop="stationName">
        <el-input v-model="searchData.stationName" placeholder="请输入" clearable></el-input>
      </el-form-item>

      <el-form-item label="京东旧机品类" prop="thirdOldCate">
        <el-select v-model="searchData.thirdOldCate" placeholder="请选择" clearable style="width: 100%">
          <el-option v-for="item in jdOldMachineCateoryOption" :key="item.thirdOldCate" :label="item.thirdOldCate" :value="item.thirdOldCate"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="承运商" prop="carrierNoList">
        <el-select v-model="searchData.carrierNoList" placeholder="请选择" clearable style="width: 100%" multiple>
          <el-option v-for="item in partnershipList" :key="item.partnershipId" :label="item.partnerName" :value="item.partnershipId"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="京东销售订单" prop="saleOrderNo">
        <el-input v-model="searchData.saleOrderNo" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="物流检验是否一致" prop="consistent">
        <el-select v-model="searchData.consistent" placeholder="请选择" clearable style="width: 100%">
          <el-option label="一致" :value="1"></el-option>
          <el-option label="不一致" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否抽检" prop="checkConsistentFlag">
        <el-select v-model="searchData.checkConsistentFlag" placeholder="请选择" clearable style="width: 100%">
          <el-option label="不抽检" :value="0"></el-option>
          <el-option label="抽检" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="抽检时间" prop="checkDate">
        <el-date-picker v-model="searchData.checkDate" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="京东入库时间" prop="finishDate">
        <el-date-picker v-model="searchData.finishDate" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="回收完成时间" prop="recycleCompleteDate">
        <el-date-picker
          v-model="searchData.recycleCompleteDate"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="再生资源入库时间" prop="warehousingDate">
        <el-date-picker
          v-model="searchData.warehousingDate"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="条码1入库状态" prop="warehousing1">
        <el-select v-model="searchData.warehousing1" placeholder="请选择" clearable style="width: 100%">
          <el-option label="未入库" :value="0"></el-option>
          <el-option label="已入库" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="条码2入库状态" prop="warehousing2">
        <el-select v-model="searchData.warehousing2" placeholder="请选择" clearable style="width: 100%">
          <el-option label="未入库" :value="0"></el-option>
          <el-option label="已入库" :value="1"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="btn-group">
      <div class="row-bg">
        <el-button type="primary" size="medium" @click="exportBtnFun" :loading="exportBtnLoading">导出</el-button>

        <div class="batch-storage-button">
          <file-upload ref="fileupload" @addUpload="importExcel" :title="'批量入库'" />
        </div>

        <el-button type="primary" size="medium" @click="batchModelDownLoadFun" :loading="batchBtnLoading">批量入库模版下载</el-button>
        <div class="batch-storage-button">
          <file-upload ref="fileupload" @addUpload="importExcelForAbnormalFun" :title="'批量异常报备'" />
        </div>

        <el-button type="primary" size="medium" @click="batchReportDownLoadFun" :loading="batchReportBtnLoading">批量报备模版下载</el-button>
        <div class="batch-storage-button">
          <file-upload ref="fileupload" @addUpload="batchLossRegistrationFun" :title="'批量登记丢失'" />
        </div>
        <el-button type="primary" size="medium" @click="lossTemplateDownLoadFun" :loading="batchReportBtnLoading">登记丢失模版下载</el-button>
      </div>
      <div class="row-bg">
        <el-button type="primary" size="medium" @click="handleSearch()">查询</el-button>
        <el-button size="medium" @click="resetForm()">重置</el-button>
      </div>
    </div>

    <el-table ref="checktableData" :data="tableData" v-loading="tableLoading" :reserve-selection="true" center height="60vh">
      <el-table-column label="操作" prop="action" width="180">
        <template slot-scope="scope">
          <el-link type="primary" v-if="scope.row.oldMachineStatus == 600" @click="recycleResourceInStoreFun(scope.row)">再生资源入库</el-link>
          <el-link type="primary" @click="rowDetailFun(scope.row)">详情</el-link>
          <el-link type="primary" @click="abnormalReportFun(scope.row)">异常报备</el-link>
          <el-link
            type="primary"
            v-if="scope.row.oldMachineStatus != 600 && scope.row.oldMachineStatus != 700 && scope.row.oldMachineStatus != 601"
            @click="handleLossFun(scope.row)"
          >
            登记丢失
          </el-link>
        </template>
      </el-table-column>
      <el-table-column label="京东工单号" prop="orderNo" width="160"></el-table-column>
      <el-table-column label="回收订单号" prop="recycleNo" width="160"></el-table-column>
      <el-table-column label="条码1" prop="oldBarCode1" width="140"></el-table-column>
      <el-table-column label="条码2" prop="oldBarCode2" width="140"></el-table-column>
      <el-table-column label="条码1入库状态" prop="warehousing1Str" width="140"></el-table-column>
      <el-table-column label="条码2入库状态" prop="warehousing2Str" width="140"></el-table-column>
      <el-table-column label="旧机状态" prop="oldMachineStatusName" width="120"></el-table-column>
      <el-table-column label="京东旧机品类" prop="thirdOldCate" width="120"></el-table-column>
      <el-table-column label="京东旧机规格" prop="fourthOldCate" width="140">
        <template slot-scope="scope">
          <!-- <span>{{ scope.row.secondOldCate }} {{ scope.row.thirdOldCate }} {{ scope.row.fourthOldCate }}</span> -->
          <span>{{ scope.row.fourthOldCate }}</span>
        </template>
      </el-table-column>
      <el-table-column label="鉴定旧机品类" prop="category" width="140"> </el-table-column>
      <el-table-column label="鉴定旧机规格" prop="specification" width="140"> </el-table-column>
      <el-table-column label="鉴定是否一致" prop="consistentStr" width="100"></el-table-column>

      <el-table-column label="鉴定是否有完整" prop="completeStr" width="100"></el-table-column>
      <el-table-column label="仓库名称" prop="stationName" width="140"></el-table-column>
      <el-table-column label="仓库编号" prop="stationId" width="140"></el-table-column>
      <el-table-column label="省" prop="province" width="100"></el-table-column>
      <el-table-column label="市" prop="city" width="100"></el-table-column>
      <el-table-column label="区" prop="county" width="100"></el-table-column>
      <el-table-column label="街道" prop="town" width="140"></el-table-column>
      <el-table-column label="详细地址" prop="address" width="160"></el-table-column>
      <el-table-column label="联系人" prop="contactName" width="120"></el-table-column>
      <el-table-column label="联系电话" prop="contactMobile" width="120"></el-table-column>
      <el-table-column label="承运商" prop="carrierName" width="120"></el-table-column>
      <el-table-column label="承运商组织" prop="carrierOrg" width="140"></el-table-column>
      <el-table-column label="回收人员" prop="recoveryWorkerName" width="120"></el-table-column>
      <el-table-column label="京东销售单号" prop="saleOrderNo" width="160"></el-table-column>
      <el-table-column label="京东完成时间" prop="finishDate" width="160"></el-table-column>
      <el-table-column label="回收完成时间" prop="recycleCompleteDate" width="160"></el-table-column>
      <el-table-column label="再生资源入库时间" prop="warehousingDate" width="160"></el-table-column>
      <el-table-column label="条码1入库时间" prop="warehousing1Date" width="160"></el-table-column>
      <el-table-column label="条码2入库时间" prop="warehousing2Date" width="160"></el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes,prev, pager, next,jumper"
        :current-page.sync="pagination.page"
        :page-size="pagination.size"
        :page-sizes="[10, 20, 30, 50]"
        :total="total"
      >
      </el-pagination>
    </div>
    <InStoreConfirmDialog ref="inStoreConfirmDialogRef" @opera-success="handleSearch"></InStoreConfirmDialog>
    <OldMachineDetDialog ref="oldMachineDetDialogRef"></OldMachineDetDialog>
    <ResDialog ref="resDialogRef"></ResDialog>
    <AbnormalReportDialog ref="abnormalReportDialogRef" @report-success="getList"></AbnormalReportDialog>
    <ResMatchAbnormalDialog ref="resMatchAbnormalDialogRef"></ResMatchAbnormalDialog>
  </div>
</template>
<script>
import AbnormalReportDialog from './components/AbnormalReportDialog.vue'
import InStoreConfirmDialog from './components/InStoreConfirmDialog.vue'
import OldMachineDetDialog from './components/OldMachineDetDialog.vue'
import ResDialog from './components/ResDialog.vue'
import ResMatchAbnormalDialog from './components/ResMatchAbnormalDialog.vue'
import fileUpload from '@/views/oldForNewService/components/FileUpload.vue'
import jdProvinceCity from './mixins/jdProvinceCity.js'
export default {
  components: {
    AbnormalReportDialog,
    InStoreConfirmDialog,
    OldMachineDetDialog,
    ResDialog,
    fileUpload,
    ResMatchAbnormalDialog
  },
  mixins: [jdProvinceCity],
  data() {
    return {
      searchData: {
        orderNo: undefined,
        recycleNo: undefined,
        barCode: undefined,
        oldMachineStatusList: undefined,
        stationId: undefined,
        provinceIds: undefined,
        cityIds: undefined,
        countyIds: undefined,
        stationName: undefined,
        thirdOldCate: undefined,
        carrierNoList: undefined,
        saleOrderNo: undefined,
        finishDate: [],
        checkDate: [],
        recycleCompleteDate: [],
        warehousingDate: [],
        consistent: undefined,
        checkConsistentFlag: undefined,
        warehousing1: undefined,
        warehousing2: undefined
      },
      oldMachineStatusList: [],
      provinceList: [],
      cityList: [],
      districtList: [],
      jdOldMachineCateoryOption: [],
      partnershipList: [],
      tableData: [],
      tableLoading: false,
      pagination: {
        page: 1,
        size: 10
      },
      total: 0,
      exportBtnLoading: false,
      batchBtnLoading: false,
      batchReportBtnLoading: false,
      lossTemplateBtnLoading: false
    }
  },
  computed: {
    // 添加计算属性来控制市和区的选择状态
    isCityDisabled() {
      // 当省份未选择或省份为多选时，禁用市选择器
      return !this.searchData.provinceIds || this.searchData.provinceIds.length === 0 || this.searchData.provinceIds.length > 1
    },
    isDistrictDisabled() {
      // 当市未选择、市为多选，或者省份为多选时，禁用区选择器
      return (
        !this.searchData.cityIds ||
        this.searchData.cityIds.length === 0 ||
        this.searchData.cityIds.length > 1 ||
        (this.searchData.provinceIds && this.searchData.provinceIds.length > 1)
      )
    }
  },
  created() {
    const pageParams = this.$route.query
    // console.log('===pageParams', pageParams)
    this.searchData = Object.assign({}, this.searchData, pageParams)
    if (pageParams.provinceIds) {
      this.searchData.provinceIds = pageParams.provinceIds
      this.provinceChangeFun()
    }
    if (pageParams.cityIds) {
      this.searchData.cityIds = pageParams.cityIds
      this.cityChangeFun()
    }
    if (pageParams.countyIds) this.searchData.countyIds = pageParams.countyIds
    this.getEnumsStatusMap()
    this.getJdTopCateroyFun()
    this.getCarrierListFun()
    this.handleSearch()
  },
  methods: {
    // 查询
    handleSearch() {
      this.pagination.page = 1
      this.getList()
    },
    // 清空
    resetForm() {
      this.searchData = {
        orderNo: undefined,
        recycleNo: undefined,
        barCode: undefined,
        oldMachineStatusList: undefined,
        stationId: undefined,
        provinceIds: undefined,
        cityIds: undefined,
        countyIds: undefined,
        stationName: undefined,
        jdOldMachineCateory: undefined,
        carrierNoList: undefined,
        saleOrderNo: undefined,
        finishDate: [],
        checkDate: [],
        recycleCompleteDate: [],
        warehousingDate: [],
        consistent: undefined,
        checkConsistentFlag: undefined,
        warehousing2: undefined,
        warehousing1: undefined
      }
      // this.handleSearch()
    },
    // 再生资源入库
    recycleResourceInStoreFun(rowData) {
      const orderNo = rowData.orderNo
      this.$refs.inStoreConfirmDialogRef.opendDialog(orderNo)
    },
    // 详情
    rowDetailFun(rowData) {
      const orderNo = rowData.orderNo
      const categoryStr = rowData.category
      this.$refs.oldMachineDetDialogRef.opendDialog(orderNo, categoryStr)
    },
    // 异常报备
    abnormalReportFun(rowData) {
      this.$refs.abnormalReportDialogRef.opendDialog(rowData)
    },
    //登记丢失
    handleLossFun(rowData) {
      const orderNo = rowData.orderNo

      // 验证 orderNo 格式
      if (!orderNo) {
        this.$message.error('工单号不能为空')
        return
      }

      const orderNoRegex = /^RE\d{16}$/
      if (!orderNoRegex.test(orderNo)) {
        this.$message.error('工单号格式不正确，应为 RE 开头 +16 位数字')
        return
      }

      this.$confirm('是否确认登记丢失？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.lossReqFun(orderNo)
      })
    },
    // 登记丢失请求
    lossReqFun(orderNo) {
      const url = `/autoapp-default-server-recovery/api/jd/recycle/order/lostRegistration`
      this.HttpService.post(url, { orderNo: orderNo }).then(
        res => {
          if (res.statusCode === 200) {
            this.$message.success('已登记')
            this.handleSearch()
          } else {
            const msgTip = res.message || '请求失败'
            this.$message.error(msgTip)
          }
        },
        err => {
          console.log('err', err)
        }
      )
    },
    // 页码改变
    handleSizeChange(val) {
      this.pagination.page = 1
      this.pagination.size = val
      this.getList()
    },
    handleCurrentChange() {
      this.getList()
    },
    getList() {
      this.tableLoading = false
      const url = '/autoapp-default-server-recovery/api/jd/recycle/order/pageCondition'
      const { finishDate = [], checkDate = [], recycleCompleteDate = [], warehousingDate = [] } = this.searchData
      const startFinishDate = finishDate[0] ? `${finishDate[0]} 00:00:00` : undefined
      const endFinishDate = finishDate[1] ? `${finishDate[1]} 23:59:59` : undefined
      const startCheckDate = checkDate[0] ? `${checkDate[0]} 00:00:00` : undefined
      const endCheckDate = checkDate[1] ? `${checkDate[1]} 23:59:59` : undefined
      const startRecycleCompleteDate = recycleCompleteDate[0] ? `${recycleCompleteDate[0]} 00:00:00` : undefined
      const endRecycleCompleteDate = recycleCompleteDate[1] ? `${recycleCompleteDate[1]} 23:59:59` : undefined
      const startWarehousingDate = warehousingDate[0] ? `${warehousingDate[0]} 00:00:00` : undefined
      const endWarehousingDate = warehousingDate[0] ? `${warehousingDate[1]} 23:59:59` : undefined
      const params = {
        ...this.searchData,
        startFinishDate,
        endFinishDate,
        startCheckDate,
        endCheckDate,
        startRecycleCompleteDate,
        endRecycleCompleteDate,
        startWarehousingDate,
        endWarehousingDate,
        // 处理多选参数
        provinceIds: this.searchData.provinceIds || undefined,
        cityIds: this.searchData.cityIds || undefined,
        countyIds: this.searchData.countyIds || undefined,
        oldMachineStatusList: this.searchData.oldMachineStatusList || undefined,
        ...this.pagination
      }
      this.HttpService.post(url, params).then(res => {
        if (res.statusCode === 200) {
          // console.log('res===', res)
          this.tableData = res.data || []
          this.total = res.total || 0
        } else {
          const msgTip = res.message || '请求出错'
          this.$message.error(msgTip)
        }
        this.tableLoading = false
      })
    },
    // 导出
    exportBtnFun() {
      this.exportBtnLoading = true
      setTimeout(() => {
        this.exportBtnLoading = false
      }, 1200)
      const url = '/autoapp-default-server-recovery/api/jd/recycle/order/export/pageCondition'
      const title = '京东旧机查询订单'
      const { finishDate = [], checkDate = [], recycleCompleteDate = [], warehousingDate = [] } = this.searchData
      const startFinishDate = finishDate[0] ? `${finishDate[0]} 00:00:00` : undefined
      const endFinishDate = finishDate[1] ? `${finishDate[1]} 23:59:59` : undefined
      const startCheckDate = checkDate[0] ? `${checkDate[0]} 00:00:00` : undefined
      const endCheckDate = checkDate[1] ? `${checkDate[1]} 23:59:59` : undefined
      const startRecycleCompleteDate = recycleCompleteDate[0] ? `${recycleCompleteDate[0]} 00:00:00` : undefined
      const endRecycleCompleteDate = recycleCompleteDate[1] ? `${recycleCompleteDate[1]} 23:59:59` : undefined
      const startWarehousingDate = warehousingDate[0] ? `${warehousingDate[0]} 00:00:00` : undefined
      const endWarehousingDate = warehousingDate[0] ? `${warehousingDate[1]} 23:59:59` : undefined
      const params = {
        ...this.searchData,
        startFinishDate,
        endFinishDate,
        startCheckDate,
        endCheckDate,
        startRecycleCompleteDate,
        endRecycleCompleteDate,
        startWarehousingDate,
        endWarehousingDate,
        // 处理多选参数
        provinceIds: this.searchData.provinceIds || undefined,
        cityIds: this.searchData.cityIds || undefined,
        countyIds: this.searchData.countyIds || undefined,
        oldMachineStatusList: this.searchData.oldMachineStatusList || undefined,
        ...this.pagination
      }
      // this.global.exportExcel(url, params, title).catch((res) => {
      // 	let blob = new Blob([res.response.data], {
      // 		type: "application/json",
      // 	})
      // 	var blobReader = new Response(blob).json()
      // 	blobReader.then((res) => {
      // 		this.$message.error(res.message)
      // 	})
      // })

      this.HttpService.post(url, params).then(res => {
        if (res.statusCode == 200) {
          this.$message.success('正在导出, 稍后请到下载中心查看')
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    importExcel(item) {
      this.upLoadData = item
      let formData = new FormData()
      formData.append('file', this.upLoadData.file)
      let url = `/autoapp-default-server-recovery/api/jd/recycle/order/importInboundInfo`
      this.HttpService.post(url, formData).then(res => {
        // console.log('===res===', res)
        if (res.statusCode === 200) {
          if (res.data) {
            let downloadId = res.data
            this.$refs.resDialogRef.opendDialog(downloadId)
          } else {
            this.$message.success('批量入库成功')
            this.handleSearch()
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 批量异常报备文件导入
    importExcelForAbnormalFun(item) {
      this.upLoadAbnormalData = item
      let formData = new FormData()
      formData.append('file', this.upLoadAbnormalData.file)
      let url = `/autoapp-default-server-recovery/api/jd/recycle/order/importReport`
      this.HttpService.post(url, formData).then(res => {
        // console.log('===res===', res)
        if (res.statusCode === 200) {
          if (res.data) {
            let downloadId = res.data
            this.$refs.resMatchAbnormalDialogRef.opendDialog(downloadId)
          } else {
            this.$message.success('批量异常报备成功')
            this.handleSearch()
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 模版下载
    batchModelDownLoadFun() {
      this.batchBtnLoading = true
      setTimeout(() => {
        this.batchBtnLoading = false
      }, 1200)
      const url = '/autoapp-default-server-recovery/api/jd/recycle/order/downLoadInboundTemplate'
      const title = '京东旧机批量入库模版'
      this.global.exportExcel(url, {}, title).catch(res => {
        let blob = new Blob([res.response.data], {
          type: 'application/json'
        })
        var blobReader = new Response(blob).json()
        blobReader.then(res => {
          this.$message.error(res.message)
        })
      })
    },
    // 批量报备模版下载
    batchReportDownLoadFun() {
      this.batchReportBtnLoading = true
      setTimeout(() => {
        this.batchReportBtnLoading = false
      }, 1200)
      const url = '/autoapp-default-server-recovery/api/jd/recycle/order/downloadTemplateReport'
      const title = '批量报备模版下载'
      this.global.exportExcel(url, {}, title).catch(res => {
        let blob = new Blob([res.response.data], {
          type: 'application/json'
        })
        var blobReader = new Response(blob).json()
        blobReader.then(res => {
          this.$message.error(res.message)
        })
      })
    },
    // 批量登记丢失
    batchLossRegistrationFun(item) {
      this.upLoadAbnormalData = item
      let formData = new FormData()
      formData.append('file', this.upLoadAbnormalData.file)
      let url = `/autoapp-default-server-recovery/api/jd/recycle/order/importLostRegistration`
      this.HttpService.post(url, formData).then(res => {
        // console.log('===res===', res)
        if (res.statusCode === 200) {
          if (res.data) {
            let downloadId = res.data
            this.$refs.resMatchAbnormalDialogRef.opendDialog(downloadId)
          } else {
            this.$message.success('批量登记丢失成功')
            this.handleSearch()
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 登记丢失模版下载
    lossTemplateDownLoadFun() {
      this.lossTemplateBtnLoading = true
      setTimeout(() => {
        this.lossTemplateBtnLoading = false
      }, 1200)
      const url = '/autoapp-default-server-recovery/api/file/downLoadTemplate'
      const title = '批量登记丢失模版下载'
      this.global.exportExcel(url, { templateName: 'jdLostRegistration' }, title).catch(res => {
        let blob = new Blob([res.response.data], {
          type: 'application/json'
        })
        var blobReader = new Response(blob).json()
        blobReader.then(res => {
          this.$message.error(res.message)
        })
      })
    },
    // 获取旧机状态
    getEnumsStatusMap() {
      const url = '/autoapp-default-server-recovery/api/jd/recycle/common/getMachineStatusMap'
      this.HttpService.get(url).then(res => {
        if (res.statusCode === 200) {
          const itemObj = res.data
          const listData = Object.entries(itemObj).map(([value, label]) => ({ label, value }))
          this.oldMachineStatusList = listData
        } else {
          const msgTip = res.message || '请求出错'
          this.$message.error(msgTip)
        }
      })
    },
    // 省改变
    provinceChangeFun() {
      this.searchData.cityIds = []
      this.searchData.countyIds = []
      // 当选择了省份时，清空市区数据
      if (this.searchData.provinceIds && this.searchData.provinceIds.length > 0) {
        // 如果选择了多个省份，则不加载城市数据
        if (this.searchData.provinceIds.length === 1) {
          this.getTblCityNew(this.searchData.provinceIds[0])
        } else {
          // 多选省份时清空城市和区县选项
          this.cityListNew = []
          this.districtListNew = []
        }
      } else {
        // 未选择省份时清空城市和区县选项
        this.cityListNew = []
        this.districtListNew = []
      }
    },
    // 市改变
    cityChangeFun() {
      this.searchData.countyIds = []
      // 当选择了城市时，只有当选择单个城市时才加载区县数据
      if (this.searchData.cityIds && this.searchData.cityIds.length > 0) {
        if (this.searchData.cityIds.length === 1 && this.searchData.provinceIds && this.searchData.provinceIds.length === 1) {
          this.getTblCountyNew(this.searchData.provinceIds[0], this.searchData.cityIds[0])
        } else {
          // 多选城市时清空区县选项
          this.districtListNew = []
        }
      } else {
        // 未选择城市时清空区县选项
        this.districtListNew = []
      }
    },
    // 获取承运商列表
    getCarrierListFun() {
      const url = '/autoapp-default-server-recovery/api/jd/partnerManagementBond/pageJdPartnerShip'
      const params = {
        currPage: 1,
        pageSize: 999999
      }
      this.HttpService.post(url, params).then(res => {
        if (res.statusCode === 200) {
          // console.log('res===', res)
          this.partnershipList = res.data || []
        } else {
          const msgTip = res.message || '请求出错'
          this.$message.error(msgTip)
        }
      })
    },
    // 获取京东旧机三级品类
    getJdTopCateroyFun() {
      // const url = '/autoapp-default-server-recovery/api/jd/recycle/category/getFirstCategory'
      const url = '/autoapp-default-server-recovery/api/jd/recycle/category/getFourthUnionCategoryAll'
      this.HttpService.get(url).then(res => {
        if (res.statusCode === 200) {
          // console.log('===res===', res)
          const listData = res.data || []
          this.jdOldMachineCateoryOption = listData
        } else {
          const msgTip = res.message || '请求出错'
          this.$message.error(msgTip)
        }
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.btn-group {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}
.batch-storage-button {
  margin-left: 10px;
  margin-right: 10px;
}
.row-bg {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/jdOldMachineRecycleManage/jdOldMachineSearch.vue